import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Loader } from "../../../components/commons";
import { UploadIcon } from "../../../assets/images";
import "./upload.scss";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { StockUploadFilePayloadType } from "../../../commonTypes/clientSettingsTypes";
import { multipleUploadFilesAction } from "../../../redux/clientSettings";

type AppProps = {
  toggleModal?: any;
  modal?: boolean;
  client_code?: number | string | null;
  token: string | null;
  fetchNewData?: any;
  isDraggableModal?: boolean;
  acceptedFiles?: string;
  supportedFiles?: string;
  maxFileSize?: number;
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) => void;
};

const SingleUploadWithApi = ({
  token,
  toggleModal,
  modal,
  client_code,
  acceptedFiles,
  supportedFiles,
  maxFileSize,
  fetchNewData,
  isDraggableModal,
  dispatchUploadFilesAction,
}: AppProps) => {
  const [fileNames, setFileNames] = useState([]);

  const [fileData, setFileData] = useState<any>("");
  const [loading, setLoading] = useState(false);

  const handleDrop = (acceptedFiles: any[string]) => {
    setFileNames(
      acceptedFiles && acceptedFiles.map((file: { name: any }) => file.name)
    );
    setFileData(acceptedFiles);
  };

  const fileUpload = () => {
    setLoading(true);
    uploadFiles(fileData);
  };

  const uploadFiles = (uploadedFile: any) => {
    const file = uploadedFile[0];
    const finalData = {
      token,
      fileData: file,
      containerType: 2,
    };
    setLoading(false);
    return dispatchUploadFilesAction(finalData);
  };

  const renderDraggableUpload = () => {
    return (
      <div>
        <Dropzone
          accept={
            acceptedFiles ??
            "image/png, image/gif, application/pdf , image/jpeg, .csv, text/csv, application/vnd.ms-excel, application/csv, text/x-csv, application/x-csv, text/comma-separated-values, text/x-comma-separated-values, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, .ppt , .pptx"
          }
          minSize={0}
          maxSize={maxFileSize ?? maxSize}
          onDrop={handleDrop}
          multiple={false}
        >
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragReject,
            fileRejections,
          }) => {
            let isFileTooLarge;
            if (maxFileSize) {
              isFileTooLarge = fileRejections[0]?.file?.size > maxFileSize;
            } else {
              isFileTooLarge = fileRejections[0]?.file?.size > maxSize;
            }

            return (
              <div
                {...getRootProps({
                  className: "dropzone drop-area text-center",
                })}
              >
                <input {...getInputProps()} />
                <img src={UploadIcon} alt="upload" />

                {isDragActive && !isDragReject && (
                  <h4 className="text-center">Drop it like it's hot!</h4>
                )}

                {isDragReject && (
                  <h4 className="text-center">
                    File type not accepted, sorry!
                  </h4>
                )}

                {!isDragActive && (
                  <h4 className="text-center">
                    Drag'n'drop files, or click to select files
                  </h4>
                )}
                <p className="text-muted text-center">
                  {`Supported formats: ${
                    supportedFiles ?? "images, PDF, excel , ppt , pptx and doc."
                  }`}{" "}
                </p>
                <p className="text-center text-muted ">
                  {`Single file upload with maximum of ${displayFileSize} MB file size supported.`}
                </p>
                {isFileTooLarge && (
                  <div className="text-danger mt-2">File is too large.</div>
                )}
              </div>
            );
          }}
        </Dropzone>
        <div>
          <ul className="list-group mt-1">
            {fileNames && fileNames.length
              ? fileNames.map((item) => (
                  <li
                    className="list-group-item active"
                    key={item}
                    style={{ wordWrap: "break-word" }}
                  >
                    {item}
                  </li>
                ))
              : null}
          </ul>
        </div>
        <ModalFooter>
          {isDraggableModal && (
            <span className="pointer" onClick={toggleModal}>
              Cancel
            </span>
          )}
          {fileNames && fileNames.length ? (
            <Button color="primary" disabled={loading} onClick={fileUpload}>
              Upload
            </Button>
          ) : null}
        </ModalFooter>
      </div>
    );
  };

  const maxSize = 10000000; //10mb file size
  const displayFileSize =
    (maxFileSize && maxFileSize / 1000000) ?? maxSize / 1000000;
  return (
    <>
      {isDraggableModal ? (
        <Modal isOpen={modal} toggle={toggleModal}>
          <ModalHeader toggle={toggleModal}>File Uploader</ModalHeader>
          <ModalBody>
            {renderDraggableUpload()}

            {loading && <Loader />}
          </ModalBody>
        </Modal>
      ) : (
        renderDraggableUpload()
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({

})

const mapDispatchToProps = (dispatch: any) => ({
  dispatchUploadFilesAction: (data: StockUploadFilePayloadType) =>
    dispatch(multipleUploadFilesAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleUploadWithApi);
